export default {
  HEX_TYPE: 'hex',
  HSL_TYPE: 'hsl',
  RGB_TYPE: 'RGB',
};
